import { Component, Injector } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { RadioCardOption } from '@hit/coverpath-design-system/lib/components/radio-card-group/radio-card-group.component';
import { Subject } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { ApplicationService } from '../../../../services/application/application.service';
import { BaseFormComponent } from '../base-form.component';

@Component({
  templateUrl: './exam-ordering-process.component.html',
})
export class ExamOrderingProcessComponent extends BaseFormComponent {
  private readonly destroy$ = new Subject<void>();
  options: RadioCardOption[] = [
    {
      label: 'Automatic',
      value: 'false',
      summary: `The exam is ordered automatically (if required) after the application is submitted. This enables online appointment scheduling through Coverpath.`,
    },
    {
      label: 'Manual',
      value: 'true',
      summary: `You will order the exam yourself (the results are still typically connected to the case automatically). You agree to collect the proper authorization signed by the applicant prior to ordering the exam/labs.`,
    },
  ];

  examOrderingProcessForm: FormGroup;
  constructor(protected injector: Injector, private fb: FormBuilder, protected appService: ApplicationService) {
    super(injector);
  }

  ngOnInit() {
    super.ngOnInit();
    const prop = this.questionItem.prop;
    const value = this.getValue(prop);
    this.examOrderingProcessForm = this.fb.group({
      examOptOut: [value],
    });

    this.updateFromModel();
    this.examOrderingProcessForm
      .get('examOptOut')
      .valueChanges.pipe(takeUntil(this.destroy$), distinctUntilChanged())
      .subscribe(async (value) => {
        this.appService.submitValueAndFireTriggers(prop, value === 'true');
      });
  }

  updateFromModel() {
    const prop = this.questionItem.prop;
    const value = this.getValue(prop);
    this.examOrderingProcessForm.get('examOptOut').setValue(value.toString());
    this.cdRef.detectChanges();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
